import _defineProperty from "/home/gitlab-runner/beki-ui-prod/beki-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var genButtonStyle = function genButtonStyle(token) {
  var _$concat$concat;

  var componentCls = token.componentCls,
      antCls = token.antCls,
      paddingXS = token.paddingXS,
      opacityLoading = token.opacityLoading;
  return _defineProperty({}, "".concat(componentCls, "-button"), _defineProperty({
    whiteSpace: 'nowrap'
  }, "&".concat(antCls, "-btn-group > ").concat(antCls, "-btn"), (_$concat$concat = {}, _defineProperty(_$concat$concat, "&-loading, &-loading + ".concat(antCls, "-btn"), {
    cursor: 'default',
    pointerEvents: 'none',
    opacity: opacityLoading
  }), _defineProperty(_$concat$concat, "&:last-child:not(:first-child):not(".concat(antCls, "-btn-icon-only)"), {
    paddingInline: paddingXS
  }), _$concat$concat)));
};

export default genButtonStyle;